import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {ModalSubheader} from 'shells/typography/modal-subheader';

type Props = {
    businessId: string;
    apiKey: string;
    setBusinessId: (businessId: string) => void;
    setApiKey: (apiKey: string) => void;
};

export function KixieForm(props: Props) {
    return (
        <>
            <ModalSubheader>
                We’ll need your Kixie Business ID and API Key to set up your integration.
            </ModalSubheader>
            <Stack spacing={16}>
                <FormField
                    innerId='businessId'
                    label='Business ID'
                    noMargin={true}
                    tooltipInfo='Your Business ID can be found in your Kixie account settings under "Integrations".'
                >
                    <TextField
                        value={props.businessId}
                        onChange={(value) => props.setBusinessId(value)}
                    />
                </FormField>
                <FormField
                    innerId='apiKey'
                    label='API Key'
                    noMargin={true}
                    tooltipInfo='Your API Key can be found in your Kixie account settings under "Integrations".'
                >
                    <TextField value={props.apiKey} onChange={(value) => props.setApiKey(value)} />
                </FormField>
            </Stack>
        </>
    );
}
